import {
  OrderStatus,
  prisma,
  type Prisma,
  ResourceType,
  ActionType,
} from "client";

export const getAttendeesBySearchParam = async (
  userId: string,
  eventId: string,
  search?: string
) => {
  try {
        // Prisma.OrderItemWhereInput
    let whereClause = {
      order: {
        AND: [
          {
            eventId: {
              equals: eventId,
            },
          },
          { status: OrderStatus.COMPLETED },
        ],
      },
    };
    // if (search) {
    //   const searchConditions = Object.keys(search).map((key) => ({
    //     formResult: {
    //       surveyResult: {
    //         contains: search[key],
    //         mode: "insensitive",
    //       },
    //     },
    //   }));

    //   // Combine multiple search conditions using OR operator
    //   whereClause = {
    //     ...whereClause,
    //     OR: searchConditions,
    //   };
    // }
    const attendees = await prisma.orderItem.findMany({
      include: {
        order: true,
        formResults: {
          include: {
            formResult: true,
          },
        },
      },
      where: whereClause,
    });
    return {
      ...attendees,
      // @ts-ignore
      formResult: attendees?.formResults[0]?.formResult,
    };
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};
